import $ from 'jquery';

require('slick-carousel/slick/slick');


$('.page-header__slider_slides').slick({
	autoplay: true,
	autoplaySpeed: 5000,
	arrows: false,
	dots: true,
	appendDots: $('.page-header__slider_dots'),
	fade: true,
	speed: 2000,
});